import type { FieldErrors, UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { ReservationFormParams } from "../../../store/draftReservation/types";

import { Block, Input, spacing } from "@stepapp/ui";

import React from "react";
import ErrorMessage from "../../ErrorMessage";
import { Grid } from "../../Grid";
import { ServiceSceneDescription, ServiceSceneHeader } from "../ServiceSceneHeader";
import AnswerItem from "./AnswerItem";

type Props = {
  errors: FieldErrors<ReservationFormParams>;
  setValue: UseFormSetValue<ReservationFormParams>;
  willCustomerBePresent: "deselected" | boolean;
  keyInfo: string;
  isHomeEditScreen?: boolean;
};

const PresenceInfoQuestion = ({
  setValue,
  willCustomerBePresent,
  errors,
  keyInfo,
  isHomeEditScreen = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Block paddingBottom={isHomeEditScreen ? 2 : 4} marginTop={1}>
      <ServiceSceneHeader name={t("pages.serviceDateAndAddress.howAreWeGoingToEnter")} />
      <ServiceSceneDescription
        marginBottom={2}
        description={t("pages.serviceDateAndAddress.howAreWeGoingToEnterDescription")}
      />

      <Grid columns={2} gap={spacing.unit * 2}>
        <AnswerItem
          onPress={() => {
            setValue("meta.willCustomerBePresent", true, {
              shouldValidate: true,
            });
          }}
          testID="presenceInfoHome"
          selected={willCustomerBePresent === true}
          title={t("pages.serviceDateAndAddress.iWillBeThere")}
        />
        <AnswerItem
          onPress={() => {
            setValue("meta.willCustomerBePresent", false, {
              shouldValidate: true,
            });
          }}
          selected={willCustomerBePresent === false}
          title={t("pages.serviceDateAndAddress.iWillLeaveTheKey")}
        />
      </Grid>
      {willCustomerBePresent === false && (
        <Block marginTop={3}>
          <Input
            multiline
            error={errors.meta?.keyInfo?.message}
            onChangeText={(value) =>
              setValue("meta.keyInfo", value, {
                shouldValidate: true,
              })
            }
            placeholder={t("components.input.placeholder.keyInfo")}
            value={keyInfo}
          />
        </Block>
      )}
      {!isHomeEditScreen && <ErrorMessage message={errors.meta?.willCustomerBePresent?.message} />}
    </Block>
  );
};

export default React.memo(PresenceInfoQuestion);
